import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNItem } from './cnitem';

@RegisterItem()
export class CNDocumentReportContent extends CNItem {
    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNDocumentReportContent';
    }

    public clone(): any {
        return new CNDocumentReportContent();
    }
}
